import Homepage from "./pages/Homepage";

import "./App.css";
import { Route } from "react-router-dom";
import ChatPage from "./pages/ChatPage";
function App() {
  return (
    <div className="App">
      <Route path="/" component={Homepage} exact />
      <Route path={"/chats"} component={ChatPage} />
    </div>
  );
}

export default App;
